$(document).ready(function() {
  AOS.init({
    once: true,
  });
  var $mobileHeaderHeight = $('#site-header').outerHeight();
  var $megaMenu = $(".mega-menu");
  var $header = $('#site-header');
  var $megaMenuButton = $(".mega-menu-button");
  var isMegaMenuOpen = false;
  var $logo = $('.logo-container');

  function updateMegaMenuPosition() {
    var headerHeight = $header.outerHeight();
    $megaMenu.css({
      'top': headerHeight + 'px',
      'height': 'calc(100vh - ' + headerHeight + 'px)'
    });
  }

  // Update mega menu position on page load and window resize
  updateMegaMenuPosition();
  $(window).on('resize', updateMegaMenuPosition);
    
  var isBreakPoint = function (bp) {
    var w = $(window).width();
    return w >= bp;
  };
  
  $(window).scroll(function () {
    if ($(this).scrollTop() > 50) {
      if (!isMegaMenuOpen) {
        $header
          .addClass("fixed top-0 left-0 right-0")
          .removeClass("absolute")
          .css("background-color", "rgba(250, 244, 230, 0.8)");
      }

      // if (isBreakPoint(1536)) {
      //   $header.css("height", "125px");
      //   $(".search-container").css("display", "none");
      //   $("#cta-header-txt").css("display", "none");
      //   $logo.css("width", "90px");

      // } else if (isBreakPoint(1280)) {
      //   $header.css("height", "100px");
      //   $(".search-container").css("display", "none");
      //   $("#cta-header-txt").css("display", "none");
      //   $logo.css("width", "70px");
      // }
      if (isBreakPoint(1280)) {
        $header.css("height", "100px");
        $(".search-container").css("display", "none");
        $("#cta-header-txt").css("display", "none");
        $logo.css("width", "70px");
      }
      } else {
      $header.css("background-color", "");
      $header.css("height", "");
      $logo.css("width", "");
      $(".search-container").css("display", "");
      $("#cta-header-txt").css("display", "");
      
    }
  });

  var $navItemWrappers = $('.nav-item-wrapper');
  var $dropdownContents = $navItemWrappers.find('.dropdown-content');

  function initDropdowns() {
    $navItemWrappers.each(function(index) {
      const $wrapper = $(this);
      const $dropdownContent = $dropdownContents.eq(index);
      const wrapperWidth = Math.max($wrapper.width(), $dropdownContent.width());
      console.log(wrapperWidth);
      $dropdownContent.css({
        'width': wrapperWidth,
        'box-sizing': 'border-box'
      });
    });
  }

  $navItemWrappers.hover(
    function() {
      $(this).find('.dropdown-content').stop(true, true).fadeIn(600);
    },
    function() {
      $(this).find('.dropdown-content').stop(true, true).fadeOut(600);
    }
  );

  $(".menu__list > li").hover(
    function () {
      $(this).find(".menu__item").addClass("border-gray-200");
      $(this).find(".menu__item").next(".menu__children").addClass("is-active");
    },
    function () {
      $(this).find(".menu__item").removeClass("border-gray-200");
      $(this)
        .find(".menu__item")
        .next(".menu__children")
        .removeClass("is-active");
    }
  );
  initDropdowns();
  $(window).on('resize', initDropdowns);

  // The mega menu parent link needs to be clickable on desktop rather than expanding the child menu

  if (isBreakPoint(1200)) {
          // console.log("Adding click handler, window width:", $(window).width());
        var megaMenuDataUrl = $('#parentMenuItem').attr('data-url');
        $("#parentMenuItem").click(function () {
            window.location.href = megaMenuDataUrl;
        });
  }

  // The mega menu parent link needs to be clickable on desktop rather than expanding the child menu
  
  
  $(".mobile-back_menu").click(function () {
    $(this).parents(".menu__children").toggleClass("is-active");
  });
  $(".mega-menu-button").click(function () {
    $(this).toggleClass("is-active");
    $("body").toggleClass("overflow-hidden");
    updateMegaMenuPosition();
    $megaMenu.toggleClass("translate-x-full translate-x-0");
    
    isMegaMenuOpen = !isMegaMenuOpen;
    
    if (isMegaMenuOpen) {
      $header.css("background-color", "var(--10pcbgColor)");
    } else {
      // Reapply the scroll-based background color
      if ($(window).scrollTop() > 50) {
        $header.css("background-color", "rgba(250, 244, 230, 0.8)");
      } else {
        $header.css("background-color", "");
      }
    }

    $(this)
      .find(".mega-menu-button-dash")
      .toggleClass("w-0 delay-[0ms] w-full delay-[400ms]");
    $(this)
      .find(".mega-menu-button-close")
      .toggleClass("w-full delay-[400ms] w-0 delay-[0ms]");
  });

});